// extracted by mini-css-extract-plugin
module.exports = {"container":"ShareProduct_container__38fQ9","thumbnail":"ShareProduct_thumbnail__KFCfc","name":"ShareProduct_name__3eUEF","brand":"ShareProduct_brand__2CYxE"};